export default __webpack_public_path__ + "static/media/Shiroko_Ridingsuit.85a91c17.png";